import ReactDom from "react-dom";
import { useState, useEffect } from "react";
import styles from "./styles.module.css";
import { storage, db } from "../../../firebase";
import { makeid } from "../../../utils/pageactions";
import { useParams } from "react-router-dom";
import { MdClose } from "react-icons/md";

import Card from "./card";
const Media = ({ onSelect, onClose }) => {
  const [tab, setTab] = useState("view");

  return (
    <div onClick={onClose} className={styles.modal}>
      <div onClick={(e) => e.stopPropagation()} className={styles.modalContent}>
        <div className={styles.modalTital}>
          App Files and Media <MdClose onClick={onClose} className="icon" />{" "}
        </div>
        <div className={styles.modalContainer}>
          <div
            style={{
              display: "flex",
              borderBottom: "1px solid var(--main-border-color)",
              width: "100%",
              padding: 15,
              boxSizing: "border-box",
            }}
          >
            <button
              className={
                tab === "view" ? `${styles.tab} ${styles.active}` : styles.tab
              }
              onClick={() => setTab("view")}
            >
              View Files
            </button>
            <button
              className={
                tab === "add" ? `${styles.tab} ${styles.active}` : styles.tab
              }
              onClick={() => setTab("add")}
            >
              Add File
            </button>
          </div>
          {tab === "view" ? (
            <ViewFiles onSelect={onSelect} />
          ) : (
            <AddFile setTab={setTab} />
          )}
        </div>
      </div>
    </div>
  );
};

const ViewFiles = ({ onSelect }) => {
  const [files, setFiles] = useState([]);
  const [selected, setSelected] = useState({ id: null });
  const [confirm, setConfirm] = useState(false);
  const params = useParams();
  useEffect(() => {
    const unsub = db
      .collection("apps")
      .doc(params.appId)
      .collection("files")
      .orderBy("uploadDate", "desc")
      .onSnapshot((snap) => {
        const files = snap.docs.map((d) => {
          return { ...d.data(), id: d.id };
        });
        setFiles(files);
      });

    return unsub;
  }, []);

  const handleDelete = () => {
    if (!confirm) {
      return setConfirm(true);
    }
    db.collection("apps")
      .doc(params.appId)
      .collection("files")
      .doc(selected.id)
      .delete()
      .then(() => {
        setSelected({ id: null });
        setConfirm(false);
      });
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        marginTop: 20,
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          maxHeight: 350,
          overflow: "auto",
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        {files.map((f) => {
          return (
            <Card
              selected={f.id === selected.id}
              onClick={(f) => setSelected(f)}
              key={f.id}
              appId={params.appId}
              file={f}
            />
          );
        })}
      </div>
      <div
        style={{
          display: "flex",
          borderTop: "1px solid var(--main-border-color)",
          width: "100%",
          padding: 15,
          boxSizing: "border-box",
        }}
      >
        <button
          disabled={!selected.id}
          onClick={handleDelete}
          className={`${styles.button} ${styles.delete}`}
        >
          {confirm ? "Are you sure?" : "Delete"}
        </button>
        {confirm && (
          <button
            onClick={() => setConfirm(false)}
            style={{ marginLeft: 20 }}
            className={styles.button}
          >
            cancel
          </button>
        )}

        {onSelect && (
          <button
            disabled={!selected.id}
            style={{ marginLeft: 20 }}
            className={styles.button}
            onClick={() => onSelect(selected)}
          >
            Select
          </button>
        )}
      </div>
    </div>
  );
};

const AddFile = ({ setTab }) => {
  const params = useParams();
  const [progress, setProgress] = useState(null);
  const [file, setFile] = useState(null);
  const handleBoxClick = () => {
    document.getElementById("file-upload").click();
  };

  const setfile = (e) => {
    if (!e.target.files[0]) {
      return;
    }

    setFile(e.target.files[0]);
  };
  const handleUpload = async (e) => {
    const id = makeid(16);
    const ref = storage.ref(`${params.appId}/${id}/${file.name}`);
    const uploadTask = ref.put(file);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress(progress);
      },
      (err) => {
        console.log(err);
      },
      () => {
        db.collection("apps")
          .doc(params.appId)
          .collection("files")
          .doc(id)
          .set({
            name: file.name,
            size: file.size,
            type: file.type,
            url: encodeURI(
              `https://uploads.brevitybuilder.com/${params.appId}/${id}/${file.name}`
            ),
            uploadDate: new Date(),
          })
          .then(() => {
            setProgress(null);
            setFile(null);
            setTab("view");
          });
      }
    );
  };
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        flexGrow: 1,
      }}
    >
      {!progress ? (
        <div
          style={{
            backgroundColor: "var(--main-light)",
            border: "4px dashed var(--main-border-color)",
            borderRadius: 5,
            width: "100%",
            marginTop: 30,
            textAlign: "center",
            padding: "20px 40px 20px 40px",
            color: "#666",
            fontFamily: "var(--font)",
            fontSize: 18,
            cursor: "pointer",
            boxSizing: "border-box",
          }}
          onClick={handleBoxClick}
        >
          {file ? file.name : "Drag File Here or Click to Upload"}
        </div>
      ) : (
        <div
          style={{
            backgroundColor: "var(--main-light)",
            borderRadius: 5,
            marginTop: 30,
            textAlign: "center",
            padding: 10,
            position: "relative",
            color: "#666",
            fontFamily: "var(--font)",
            fontSize: 18,
            cursor: "pointer",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              bottom: 0,
              backgroundColor: "var(--main)",
              width: `${progress}%`,
            }}
          ></div>
          uploading - {progress}%
        </div>
      )}
      <input
        onChange={setfile}
        type="file"
        id="file-upload"
        style={{ display: "none" }}
      />
      <button
        disabled={!file || progress}
        style={{ marginTop: 20 }}
        className={styles.button}
        onClick={handleUpload}
      >
        Upload
      </button>
    </div>
  );
};

export default function Files({ open, onSelect, onClose }) {
  if (!open) {
    return <></>;
  }
  return ReactDom.createPortal(
    <Media onSelect={onSelect} onClose={onClose} />,
    document.getElementById("modals")
  );
}
